import { PageHeader } from '../components/ui/PageHeader'
import { AttentionToday } from '../features/dashboard/AttentionToday'
import { MetricStrip, type MetricItem } from '../features/dashboard/MetricStrip'
import type { CrmDataset } from '../types/crm'
import { formatCurrency } from '../utils/format'

export function DashboardPage({ dataset }: { dataset: CrmDataset }) {
  const { metrics } = dataset

  const metricItems: MetricItem[] = [
    { label: 'Total Leads', value: metrics.totalLeads, note: 'Combined records' },
    { label: 'Owners Identified', value: metrics.ownersIdentified },
    { label: 'Missing Owners', value: metrics.missingOwners },
    { label: 'Open Opportunities', value: metrics.openOpportunities },
    { label: 'Pipeline Value', value: formatCurrency(metrics.pipelineValue), emphasis: true },
  ]

  return (
    <div className="page dashboard-page">
      <PageHeader
        title="Dashboard"
        description="Your live action queue and pipeline health, grounded in the current CRM."
      />

      <MetricStrip metrics={metricItems} />

      <AttentionToday dataset={dataset} />
    </div>
  )
}
